import { pick, omit, joinPath } from "@constructor/services";
import { c as cleanSlash } from "./path.js";
function isRouteLocationByResolver(to) {
  return typeof to === "object" && "target" in to;
}
function isRouteLocationNameObject(to) {
  return typeof to === "object" && "name" in to;
}
function normalizeResolvedLocation(resolvedLocation, to) {
  if (typeof resolvedLocation === "string") {
    const { path, query } = splitUrl(resolvedLocation);
    return {
      ...pick(to, ["hash", "replace", "force"]),
      path,
      query: { ...to.query, ...query }
    };
  }
  return {
    ...pick(to, ["hash", "replace", "force", "query"]),
    ...resolvedLocation,
    query: { ...to.query, ...resolvedLocation.query },
    params: { ...to.params, ...resolvedLocation.params }
  };
}
function normalizeLocation(to, options) {
  var _a;
  const commonProps = ["query", "hash", "replace", "force"];
  if (isRouteLocationByResolver(to)) {
    const { target } = to;
    const resolverOptions = pick(to, ["params", ...commonProps]);
    const result = (_a = options.resolver) == null ? void 0 : _a.call(options, target, resolverOptions);
    if (!result && target.type === "name") {
      return { ...resolverOptions, name: target.name };
    }
    if (!result) {
      throw new Error(
        `Failed to resolve route.
To: ${JSON.stringify(to)}
Please, configure "resolver" option in federation root router config`
      );
    }
    return normalizeResolvedLocation(result, to);
  }
  if (isRouteLocationNameObject(to)) {
    console.warn(
      'Passing "name" to federation router is deprecated. Use defineFragmentExternalTarget() instead.\nMore info at https://wiki.constr.dev/doc/routing-nbNzs9OPv0#h-resolver-routes'
    );
    const nameRoute = pick(to, [
      "name",
      "params",
      ...commonProps
    ]);
    if (!options.resolver) {
      return nameRoute;
    }
    const target = { type: "name", name: nameRoute.name };
    const resolverOptions = omit(nameRoute, ["name"]);
    const result = options.resolver(target, resolverOptions);
    if (!result) {
      return nameRoute;
    }
    return normalizeResolvedLocation(result, to);
  }
  const route = typeof to === "string" ? { path: to } : pick(to, ["path", ...commonProps]);
  if ("path" in route) {
    if (!route.path) {
      throw new Error(`Fragment can't set "path" param to empty string`);
    }
    route.path = joinPath(options.base, route.path);
  }
  return route;
}
function splitUrl(url) {
  const [path, query] = url.split("?");
  const result = { path };
  if (query) {
    result.query = convertSearchToQuery(query);
  }
  return result;
}
function convertSearchToQuery(search) {
  if (!search) {
    return {};
  }
  const query = {};
  for (const [key, value] of new URLSearchParams(search)) {
    if (!(key in query)) {
      query[key] = value;
      continue;
    }
    if (!Array.isArray(query[key])) {
      query[key] = [query[key]];
    }
    query[key] = [...query[key], value];
  }
  return query;
}
function removeBase(path, base) {
  return joinPath("/", path.slice(base.length));
}
function normalizeBase(base) {
  return base && cleanSlash(base) || "/";
}
function mergeBases(base1, base2) {
  return cleanSlash(joinPath(base1 ?? "/", base2 ?? "/")) || "/";
}
export {
  isRouteLocationNameObject as a,
  normalizeLocation as b,
  convertSearchToQuery as c,
  normalizeBase as d,
  isRouteLocationByResolver as i,
  mergeBases as m,
  normalizeResolvedLocation as n,
  removeBase as r,
  splitUrl as s
};
//# sourceMappingURL=router.js.map
